module.exports = __webpack_public_path__ + "assets/img/collect-cards-dark2.37a9ea6e.png";